import axios from 'axios';
import * as imageConversion from 'image-conversion';
//处理时间自动补全加0
function filterTime(data) {
  let nowYear = data.getFullYear().toString()
  let nowMonth = (data.getMonth() + 1).toString()
  let nowDay = data.getDate().toString();
  let nowHours = data.getHours().toString(); //获取当前小时数(0-23)
  let nowMin = data.getMinutes().toString(); //获取当前分钟数(0-59)
  let nowSeconds = data.getSeconds().toString(); //获取当前秒数(0-59)
  function timeAdd0(str) {
    if (str.length <= 1) {
      str = '0' + str;
    }
    return str
  }
  nowYear = timeAdd0(nowYear)
  nowMonth = timeAdd0(nowMonth)
  nowDay = timeAdd0(nowDay)
  nowHours = timeAdd0(nowHours)
  nowMin = timeAdd0(nowMin)
  nowSeconds = timeAdd0(nowSeconds)
  let filterTime = `${nowYear}-${nowMonth}-${nowDay}T${nowHours}:${nowMin}:${nowSeconds}`
  console.log(filterTime)
  return filterTime
}
//时间戳转换为年月日时分秒的格式
function timestampToTime(timestamp) {
  let strDate = ''
  var date = new Date(Number(timestamp));//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
  var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
  var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());

  strDate = Y + M + D + h + m + s;
  return strDate;

}
function uploadImgToQiniu(file, QiniuData) {
  // file图片的文本流   QiniuData{key：'',token:''} key：`KSAX/System/image/${new Date().getTime()}.png` token：七牛token
  let qiniuImgUrl = ''
  const axiosInstance = axios.create({
    withCredentials: false
  }); //withCredentials 禁止携带cookie，带cookie在七牛上有可能出现跨域问题
  let data = new FormData();
  data.append('token', QiniuData.token);
  data.append('file', file);
  data.append('key', QiniuData.key);
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: 'POST',
      url: 'https://up.qiniup.com', //上传地址
      data: data,
      timeout: 30000, //超时时间，因为图片上传有可能需要很久
    }).then(data => {
      qiniuImgUrl = `http://ksaximg.ksaxshop.com/${data.data.key}`
      resolve(qiniuImgUrl)
      //上传成功...  (登录七牛账号，找到七牛给你的 URL地址) 和 data里面的key 拼接成图片下载地址
    }).catch(function (err) {
      //上传失败
      reject(err)
    });
  })
}

function uploadVideoToQiniu(file, QiniuData) {
  const reader = new FileReader()
  reader.onload = e => {
    let data
    if (typeof e.target.result === 'object') {
      data = window.URL.createObjectURL(new Blob([e.target.result]))
    } else {
      data = e.target.result
    }
  }
  reader.readAsDataURL(file)
  const axiosInstance = axios.create({
    withCredentials: false
  });
  let data = new FormData();
  data.append('token', QiniuData.token);
  data.append('file', file);
  data.append('key', QiniuData.key);
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: 'POST',
      url: 'https://up.qiniup.com',
      data: data,
      timeout: 30000,
    }).then(data => {
      const url = `http://ksaximg.ksaxshop.com/${data.data.key}`
      resolve(url)
    }).catch(function (err) {
      reject(err)
    });
  })
}

// 处理金额
function fmoney(s) {
  s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(2) + "";
  var l = s.split(".")[0].split("").reverse(),
    r = s.split(".")[1];
  var t = "";
  for (var i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
  }
  return t.split("").reverse().join("") + "." + r;
}

// 把秒划分成 时/分
function hourFilter(s) {
  var hours = Math.floor(s / 3600)
  var min = (((s % 3600) / 3600) * 60).toFixed(0)
  var Time = `${hours}小时${min}分钟`
  return Time
}
// 把分划分成 天/时/分

function dayFilter(StatusMinute) {
  var day = parseInt(StatusMinute / 60 / 24);
  var hour = parseInt(StatusMinute / 60 % 24);
  var min = parseInt(StatusMinute % 60);
  StatusMinute = "";
  if (day > 0) {
    StatusMinute = day + "天";
  }
  if (hour > 0) {
    StatusMinute += hour + "小时";
  }
  if (min > 0) {
    StatusMinute += parseFloat(min) + "分钟";
  }
  //三元运算符 传入的分钟数不够一分钟 默认为0分钟，else return 运算后的StatusMinute
  return StatusMinute == "" ? "0分钟" : StatusMinute;
}

function filterDate(s) {
  var year = s.getFullYear()
  var month = s.getMonth() + 1
  var date = s.getDate()
  var hours = s.getHours()
  var min = s.getMinutes()
  var sec = s.getSeconds()
  function timeAdd0(str) {
    str = str + ''
    if (str.length <= 1) {
      str = '0' + str;
    }
    return str
  }
  var nowYear = timeAdd0(year)
  var nowMonth = timeAdd0(month)
  var nowDay = timeAdd0(date)
  var nowHours = timeAdd0(hours)
  var nowMin = timeAdd0(min)
  var nowSeconds = timeAdd0(sec)
  var dataTime = nowYear + '-' + nowMonth + '-' + nowDay + ' ' + nowHours + ':' + nowMin + ':' + nowSeconds
  return dataTime
}

//月份
function monthHasDaysTar(TargetGMV, Month) {
  var year = (new Date()).getFullYear();
  var day = (new Date).getDate()
  if (Month == 1 ||
    Month == 3 ||
    Month == 5 ||
    Month == 7 ||
    Month == 8 ||
    Month == 10 ||
    Month == 12) {
    return ((TargetGMV / 31).toFixed(2) * day) / TargetGMV * 100
  } else if (Month == 4 ||
    Month == 6 ||
    Month == 9 ||
    Month == 11) {
    return ((TargetGMV / 30).toFixed(2) * day) / TargetGMV * 100
  } else {
    if (year % 4 == 0) {
      return ((TargetGMV / 29).toFixed(2) * day) / TargetGMV * 100
    } else {
      return ((TargetGMV / 28).toFixed(2) * day) / TargetGMV * 100
    }
  }
}

//数字单位换算
function dataFormatting(s) {
  if (s > 0) {
    if (s > 99999999) {
      return (Number(s) / 100000000).toFixed(4) + '亿'
    } else if (s > 9999) {
      return (Number(s) / 10000).toFixed(4) + '万'
    } else {
      return s.toFixed(2)
    }

  } else {
    return 0
  }
}
function compressAccurately(inputFile, toSize) {
  return new Promise((resolve) => {
    //   imageConversion.compressAccurately(inputFile, toSize).then(res => {
    //     console.log(res)
    //     let newFile = new window.File(
    //       [res],
    //       inputFile.name,
    //       {type: inputFile.type}
    //     )
    //     resolve(newFile)
    //   });
    let isLt2M = inputFile.size / 1024 / 1024 < 4 // 判定图片大小是否小于4MB
    if (isLt2M) {
      resolve(inputFile)
    }
    // 压缩到400KB,这里的400就是要压缩的大小,可自定义
    imageConversion.compressAccurately(inputFile, toSize).then(res => {
      let newFile = new window.File(
        [res],
        inputFile.name,
        { type: inputFile.type }
      )
      resolve(newFile)
    })
  })
}

// 元素隐藏
function hiddenFun() {
  return true
}
// 文件后缀名
function functionSplit(params) {
  if (params) {
    return params.split('.')[params.split('.').length - 1]
  } else {
    return ''
  }
}

function sortDataArrayAsc(dataArray, property) {
  return dataArray.sort(function (a, b) {
    return a[property] - b[property];
  });
}


function downloadBase64Image(base64Url, fileName) {
  try {
    // 1. 校验Base64格式是否合法
    if (!base64Url || !base64Url.startsWith('data:image/')) {
      console.error('Base64地址格式错误，必须包含data:image/xxx;base64,前缀');
      alert('图片地址格式错误，无法下载');
      return false;
    }

    // 2. 创建隐藏的a标签用于下载
    const link = document.createElement('a');
    link.style.display = 'none';

    // 3. 将Base64转换为Blob对象（解决大图片下载卡顿问题）
    const byteCharacters = atob(base64Url.split(',')[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: base64Url.split(';')[0].split(':')[1] // 提取图片类型（如image/png）
    });

    // 4. 处理不同浏览器的URL兼容
    const blobUrl = window.URL.createObjectURL(blob);
    link.href = blobUrl;
    link.download = fileName || 'download_image.png'; // 默认文件名

    // 5. 触发下载
    document.body.appendChild(link);
    link.click();

    // 6. 清理资源，避免内存泄漏
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);

    console.log('图片下载成功');
    return true;
  } catch (error) {
    console.error('图片下载失败：', error);
    alert('下载失败，请重试');
    return false;
  }
}

export default {
  filterTime: filterTime,
  timestampToTime: timestampToTime,
  uploadImgToQiniu: uploadImgToQiniu,
  uploadVideoToQiniu: uploadVideoToQiniu,
  fmoney: fmoney,
  hourFilter: hourFilter,
  filterDate: filterDate,
  monthHasDaysTar: monthHasDaysTar,
  dataFormatting: dataFormatting,
  compressAccurately: compressAccurately,
  hiddenFun: hiddenFun,
  functionSplit: functionSplit,
  dayFilter: dayFilter,
  sortDataArrayAsc: sortDataArrayAsc,
  downloadBase64Image
}
